import React from 'react'
import {component_tool} from '@/tool'
import {WizTableForm} from "../../../common";

const organizationConfig = WizTableForm.Config.organization(this, {apiParams: {state: 1}})
const positionConfig = WizTableForm.Config.position(this, {apiParams: {state: 1}})
let {WizDataTable, WizIcon, WizButton, WizDivider, WizPopover} = component_tool

export default (self, employees, other) => {
  return [
    {
      title: 'stageId',
      name: 'stageId',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: 'personId',
      name: 'personId',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '账号',
      name: 'account',
      tableItem: {},
      formItem: {
        rules: [{
          required: true,
          message: '请输入账号'
        }],
      }
    },
    {
      title: '姓名',
      name: 'name',
      searchItem: {}
    },
    {
      title: '账号',
      name: 'account',
      searchItem: {}
    },
    {
      title: '组织',
      name: 'orgIds',
      searchItem: {
        ...organizationConfig,
        diy: WizTableForm,
      }
    },
    {
      title: "岗位",
      name: "positionIds",
      searchItem: {
        diy: WizTableForm,
        ...positionConfig,
      }
    },

    {
      title: '姓名',
      name: 'fullName',
      tableItem: {},
      formItem: {
        rules: [{
          required: true,
          message: '请输入姓名'
        }],
      }
    },
    {
      title: '手机号',
      name: 'mobile',
      tableItem: {},
      formItem: {}
    },
    {
      title: '身份证号/工号',
      name: 'idCard',
      tableItem: {},
      formItem: {}
    },
    {
      title: '账号状态',
      name: 'accountState',
      tableItem: {},
      formItem: {},
      dict: [
        {code: 1, codeName: '禁用'},
        {code: 0, codeName: '激活'}
      ]
    },
    {
      title: '任职',
      name: 'userIdentityInfos',
      tableItem: {
        width: 150,
        render: (text, record) => {
          let contextList = text && text.split(',').length ? text.split(',') : []
          let content = [];
          let title = ''
          contextList && contextList.length && contextList.map((d, index) => {
            if (index === 0) {
              title = d
            }
            content.push(<p key={index}>{d}</p>)
          })
          let _titleView = []
          _titleView.push(title)
          if (contextList && contextList.length > 1) {
            _titleView.push(<span className='wiz-press-font-color'> ...</span>)
          }
          return (
            <WizPopover content={content} placement="rightTop">
              {_titleView}
            </WizPopover>
          )
        }
      }
    },
    {
      title: '最高阶段',
      name: 'highestName',
      tableItem: {},
      formItem: {}
    },
    {
      title: '操作',
      tableItem: {
        width: 200,
        render: (text, record) => (
          <WizDataTable.Oper>
            <WizButton type="link" onClick={e => self.openModel(record)}>查看学员路径</WizButton>
            {/*<WizButton type="link" onClick={e => self._onManagement(record)}>查看任职</WizButton>*/}
          </WizDataTable.Oper>
        )
      }
    }
  ]
}
